module.exports = __webpack_public_path__ + "img/footer_logo.f46bd68b.png";